import React from 'react';
import { Images, isAdmin, isAgent, isFactored, loadProfit, PermissionsList, RolePermission, userType } from 'utils';
import {
  DateRow,
  PriceRow,
  TextRow,
  LoadIconAndTitle,
  TypeRow,
  TextToolTip,
  PriceConvertor,
  HyperLinkRow,
} from 'components';
import { loadSearchEnums, loadStatusEnum } from '../constants';

export const loadsHead = (type) => {
  return [
    { name: 'displayId', searchKey: 'LOAD_DISPLAY_ID', title: 'Load ID', custom: false },
    { name: 'createdDate', title: 'Date', icon: 'date', smallSize: 6, type: 'date', width: '90px' },
    { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
    { name: 'carrier', searchKey: 'CARRIER', title: 'Vendor', custom: false },
    { name: 'agent', searchKey: 'AGENT', nameRow: 'name', title: 'Agent', custom: false },
    { name: '', title: 'Pick Up', custom: false },
    { name: '', title: 'Drop Off', custom: false },
    { name: 'customerRate', title: 'Customer Rate', smallSize: 4, custom: false },
    { name: 'carrierRate', title: 'Vendor Rate', smallSize: 4, custom: false },
    // { name: 'carrierRate', title: 'Vendor Paid', smallSize: 4, custom: false },
    { name: 'profit', title: 'Profit', custom: false },
    { name: 'status', title: 'Status', custom: false, width: '110px' },
  ];
};

export const loadsBody = (type, rowClick) => {
  return [
    {
      rowText: (item) => (
        <div onClick={() => rowClick(item)} style={{ textDecoration: item?.loadGroup ? 'underline' : 'unset' }}>
          <LoadIconAndTitle icon={Images.loadOutline} title={item?.displayId} item={item} />
        </div>
      ), notClickable: true,
    },
    { rowText: (item) => <DateRow date={item?.createdDate} /> },
    {
      rowText: (item) =>
        <div>
          <div className="align-center" style={{ gap: '4px' }}>
            {(item?.customer?.prepaid && isAdmin) &&
              <TextToolTip
                wrapperStyles={{
                  width: '18px',
                  minWidth: '18px',
                  height: '18px',
                }}
                text={
                  <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                    <img
                      src={Images.dollarSvg}
                      alt="prepaid"
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                }
                content="Customer Prepaid"
                showTooltip
              />
            }
            <HyperLinkRow
              name={item?.customer?.name}
              href={RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) ? `/customer/${item?.customer?.id}` : ''}
              checkPermission={item?.customer?.id ? RolePermission([PermissionsList.READ_CUSTOMER?.code, PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) : null}
            />
          </div>

          <div className={'table-second-item'}>
            <TextRow name={item?.customerReference ? item?.customerReference : ''} textWidth={8} color={'#9C9EA9'} />
          </div>
        </div>,
    },
    {
      rowText: (item) =>
        <div>
          <div className="align-center" style={{ gap: '4px' }}>
            {(item?.vendorPrepaid) &&
              <TextToolTip
                wrapperStyles={{
                  width: '18px',
                  minWidth: '18px',
                  height: '18px',
                }}
                text={
                  <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                    <img
                      src={Images.dollarSvg}
                      alt="prepaid"
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                }
                content="Vendor Prepaid"
                showTooltip
              />
            }

            <HyperLinkRow
              name={item?.carrier?.name}
              href={RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) ? `/vendor/${item?.carrier?.id}` : ''}
              checkPermission={item?.carrier?.id ? RolePermission([PermissionsList.READ_CARRIER?.code, PermissionsList.CREATE_UPDATE_CARRIER?.code]) : null}
            />
          </div>

            {/*<TextRow name={item?.carrier?.name ? item?.carrier?.name : 'N/A'} textWidth={8} />*/}
            <div className={'table-second-item'}>
              <TextRow name={item?.carrierReference ? item?.carrierReference : ''} textWidth={8} color={'#9C9EA9'} />
            </div>
        </div>,
    },
    {
      rowText: (item) =>
        <div>
          <HyperLinkRow
            name={item?.agent?.name}
            href={RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) ? `/agent/${item?.agent?.id}` : ''}
            checkPermission={item?.agent?.id ? RolePermission([PermissionsList.READ_AGENT?.code, PermissionsList.CREATE_UPDATE_AGENT?.code]) : null}
          />
          {/*<TextRow name={item?.agent?.name} textWidth={8} />*/}
          <div className={'table-second-item'}>
            <TextRow name={item?.branch?.name} textWidth={8} color={'#9C9EA9'} />
          </div>
        </div>,
    },
    {
      rowText: (item) => {
        const pick = item?.stops?.find((i) => i.type === 'PICKUP');

        return pick ? <div>
            <TextRow
              name={`${pick?.address?.city ? pick?.address?.city : ''} ${pick?.address?.state ? pick?.address?.state : ''}`}
              textWidth={8} />
            <div className={'table-second-item'}>
              <DateRow date={pick?.date} color={'#9C9EA9'} />
            </div>
          </div>
          :
          '...';
      },
    },
    {
      rowText: (item) => {
        const pick = item?.stops?.find((i) => i.type === 'DROPOFF');

        return pick ? <div>
            <TextRow
              name={`${pick?.address?.city ? pick?.address?.city : ''} ${pick?.address?.state ? pick?.address?.state : ''}`}
              textWidth={8} />
            <div className={'table-second-item'}>
              <DateRow date={pick?.date} color={'#9C9EA9'} />
            </div>
          </div>
          :
          '...';
      },
    },
    { rowText: (item) => <PriceRow info={item?.customerRate} /> },
    { rowText: (item) => <PriceRow info={item?.carrierRate} /> },
    // { rowText: (item) => <PriceRow info={item?.payable?.totalPaid} /> },
    { rowText: (item) => <PriceConvertor price={loadProfit(item)} /> },
    { rowText: (item) => statusRow(item) },
  ];
};


export const groupsHead = [
  { name: 'displayId', searchKey: 'LOAD_DISPLAY_ID', title: 'Group ID', custom: false },
  { name: 'createdDate', title: 'Date', icon: 'date', type: 'date', width: '90px' },
  { name: 'customer', searchKey: 'CUSTOMER', title: 'Customer', custom: false },
  { name: 'agent', searchKey: 'AGENT', nameRow: 'name', title: 'Agent', custom: false },
  { name: 'totalLoads', title: 'Total Loads', custom: false },
  { name: '', title: 'Total Customer Rate', custom: false },
  { name: '', title: 'Total Vendor Rate', custom: false },
  { name: '', title: 'Agent Charges', custom: false },
  { name: '', title: 'Total Agent Profit ', custom: false },
  { name: '', title: 'Ready for billing', custom: false, width: '122px' },
  { name: 'status', title: 'Status', custom: false, width: '110px' },
];

export const groupsBody = [
  { rowText: (item) => <LoadIconAndTitle icon={Images.loadOutline} title={item?.displayId} item={item} /> },
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  {
    rowText: (item) =>
      <div>
        <div className="align-center" style={{ gap: '4px' }}>
          {(item?.customer?.prepaid && isAdmin) &&
            <TextToolTip
              wrapperStyles={{
                width: '18px',
                minWidth: '18px',
                height: '18px',
              }}
              text={
                <div style={{ width: '100%', minWidth: '100%', height: '100%' }}>
                  <img
                    src={Images.dollarSvg}
                    alt="prepaid"
                    style={{ width: '100%', height: '100%' }}
                  />
                </div>
              }
              content="Customer Prepaid"
              showTooltip
            />
          }

          <TextRow name={item?.customer?.name} textWidth={8} />
        </div>
        <div className={'table-second-item'}>
          <TextRow name={item?.customerReference ? item?.customerReference : ''} textWidth={8}
                   color={'#9C9EA9'} />
        </div>
      </div>,
  },
  {
    rowText: (item) =>
      <div>
        <TextRow name={item?.agent?.name} textWidth={8} />
        <div className={'table-second-item'}>
          <TextRow name={item?.branch?.name} textWidth={8} color={'#9C9EA9'} />
        </div>
      </div>,
  },
  { rowText: (item) => <TextRow name={item?.totalLoads} /> },
  { rowText: (item) => <PriceRow info={item?.totalCustomerRate} /> },
  { rowText: (item) => <PriceRow info={item?.totalVendorRate} /> },
  { rowText: (item) => <PriceRow info={item?.totalAgentCharges} /> },
  { rowText: (item) => <PriceRow info={item?.totalAgentProfit} /> },
  {
    rowText: (item) => <TextRow
      name={item?.readyForBilling ? 'ON' : 'OFF'}
      styles={{ color: item?.readyForBilling ? '#43BA4D' : '#E63946', fontWeight: '600' }}
    />,
  },
  { rowText: (item) => statusRow(item) },
];

export const LOAD_ACTION_TYPE = 'GET_LOADS_BY_STATUS';
export const GROUP_ACTION_TYPE = 'GET_GROUPED_LOADS';


export const statusRow = (item) => {
  return <p
    style={{ whiteSpace: 'nowrap' }}
    className={
      item?.status === 'PROCESSING' ? 'processing-icon-color' :
        item?.status === loadStatusEnum.PENDING_FLOAT ? 'pending-float-icon-color' :
          item?.status === 'PENDING' ? 'pending-icon-color' :
            item?.status === 'INTRANSIT' ? 'inTransit-icon-color' :
              item?.status === 'REJECTED' ? 'rejected-icon-color' :
                item?.status === 'COMPLETED' ? 'completed-icon-color' :
                  ''}
  >
    {
      item?.status === 'INTRANSIT' ? 'In Transit' :
        item?.status === 'CREDITCHECK' ? 'Credit Check' :
          item?.status === 'CONSIGNMENT_REQUEST' ? 'Consignment Request' :
            item?.status === loadStatusEnum.PENDING_FLOAT ? 'Float' :
              <TypeRow text={item?.status} />
    }
  </p>;
};

export const loadCsv = {
  type: 'load',
  statusList: [
    { name: `Pending`, id: 'PENDING' },
    { name: `In Transit`, id: 'INTRANSIT' },
    { name: `Rejected`, id: 'REJECTED' },
    { name: `Processing`, id: 'PROCESSING' },
    { name: `Float`, id: loadStatusEnum.PENDING_FLOAT },
    { name: 'Cancelled', id: 'CANCELLED' },
    { name: `Completed`, id: 'COMPLETED' },
    { name: `Credit Check`, id: 'CREDITCHECK' },
    { name: `Verification`, id: 'LOAD_VERIFICATION' },
    { name: `Revision`, id: 'LOAD_REVISION' },
  ],
  statusEnum: 'department',
  office: !isAgent,
  customer: !isAgent,
  multiple: true,
  dateFilter: true,
  requiredStatus: false,
  requiredDateRange: true,
};

export const loadCsvFactored = {
  type: 'loadFactored',
  statusList: [
    { name: `Pending`, id: 'PENDING' },
    { name: `In Transit`, id: 'INTRANSIT' },
    { name: `Rejected`, id: 'REJECTED' },
    { name: `Processing`, id: 'PROCESSING' },
    { name: `Float`, id: loadStatusEnum.PENDING_FLOAT },
    { name: 'Cancelled', id: 'CANCELLED' },
    { name: `Completed`, id: 'COMPLETED' },
    { name: `Credit Check`, id: 'CREDITCHECK' },
    { name: `Verification`, id: 'LOAD_VERIFICATION' },
    { name: `Revision`, id: 'LOAD_REVISION' },
  ],
  noDesc: true,
  multiple: true,
  dateFilter: true,
  requiredStatus: false,
  requiredDateRange: false,
};

export const groupCsv = {
  type: 'group',
  modalTitle: 'All data within the selected date range and status.',
  statusList: [
    { name: `Pending`, id: 'PENDING' },
    { name: `Processing`, id: 'PROCESSING' },
    { name: 'Cancelled', id: 'CANCELLED' },
    { name: `Completed`, id: 'COMPLETED' },
  ],
  statusEnum: 'statuses',
  dateFilter: true,
  requiredStatus: false,
  requiredDateRange: true,
};

export const loadTabs = {
  LOADS: 'LOADS',
  LOAD_GROUPS: 'LOAD_GROUPS',
};
